import { BreadcrumbItem, Breadcrumbs } from '@components/Breadcrumbs'
import { ImgixImage } from '@components/gassan-ui/Image/ImgixImage'
import { cn } from '@lib/cn'
import { FC } from 'react'

type GalleryProps = {
  image: string
  alt: string
  breadcrumbItems: BreadcrumbItem[]
}

const ProductImage: FC<GalleryProps> = ({ image, alt, breadcrumbItems }) => {
  return (
    <>
      <section
        className={cn(
          'relative w-full bg-shade-50',
          'before:block before:pt-[107.5%] before:content-[""]',
          'sm:before:pt-[74%]',
          'lg:before:pt-[70%]',
        )}
      >
        <div
          className={cn(
            'absolute top-0 z-[5] flex w-full justify-between px-4 pt-4',
            'sm:px-8 sm:pt-6',
            'lg:px-10',
          )}
        >
          <Breadcrumbs items={breadcrumbItems} />
        </div>
        <ImgixImage
          src={image}
          alt={alt}
          objectFit="contain"
          className={cn(
            'absolute left-0 top-0 h-full w-full bg-shade-50 opacity-100 transition-opacity duration-300',
            '[&>img]:object-[top_center]',
            'sm:[&>img]:object-center',
          )}
        />
      </section>
    </>
  )
}

export default ProductImage
